import { useOutletContext } from "react-router-dom"

export default function withOutletContext(WrappedComponent) {
  const WithOutletContextWrapper = function (props) {
    const context = useOutletContext()
    return <WrappedComponent {...{
      ...props,
      ...context,
    }}
    />
  }
  WithOutletContextWrapper.displayName = `withOutletContext(${WrappedComponent.displayName || WrappedComponent.name})`
  return WithOutletContextWrapper
}
